import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { LogementItems } from "@/components/LogementItems";
import { useFilters } from "@/context/FilterContext";
import { api, errMsg } from "@/lib/api";

import { TYPES_LOCATION as TYPES } from "@/lib/locations";

const titre = (s) => (s || "").toLowerCase().replace(/(^|[\s-])\S/g, (c) => c.toUpperCase());

export const RevenuDirectForm = ({ depot, onDone }) => {
  const { options } = useFilters();
  const [f, setF] = useState({ type: "loyer", logement: "", locataire: titre(depot.payeur), memoriser: !!depot.payeur });
  const [loading, setLoading] = useState(false);
  const set = (k) => (v) => setF((x) => ({ ...x, [k]: v }));

  const submit = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(`/transactions/${depot.id}/revenu-direct`, f);
      toast.success(`Dépôt associé à ${f.logement}${data.associees ? ` · ${data.associees} autre(s) virement(s) de ce payeur associé(s)` : ""}`);
      onDone();
    } catch (e) { toast.error(errMsg(e)); } finally { setLoading(false); }
  };

  return (
    <div className="space-y-3" data-testid="revenu-direct-form">
      <div className="grid grid-cols-1 gap-3">
        <div><Label className="text-xs">Type</Label>
          <Select value={f.type} onValueChange={set("type")}>
            <SelectTrigger className="h-9" data-testid="revenu-direct-type"><SelectValue /></SelectTrigger>
            <SelectContent>{TYPES.map(([k, l]) => <SelectItem key={k} value={k} data-testid={`revenu-direct-type-${k}`}>{l}</SelectItem>)}</SelectContent>
          </Select></div>
        <div><Label className="text-xs">Logement</Label>
          <Select value={f.logement} onValueChange={set("logement")}>
            <SelectTrigger className="h-9" data-testid="revenu-direct-logement"><SelectValue placeholder="Choisir un logement" /></SelectTrigger>
            <SelectContent><LogementItems logements={options.logements} testPrefix="revenu-direct-logement" /></SelectContent>
          </Select></div>
      </div>
      <div><Label className="text-xs">Locataire / client</Label>
        <Input value={f.locataire} onChange={(e) => set("locataire")(e.target.value)} className="h-9" data-testid="revenu-direct-locataire" /></div>
      {depot.payeur && (
        <label className="flex items-start gap-2 text-xs text-slate-600 cursor-pointer">
          <Checkbox checked={f.memoriser} onCheckedChange={(v) => set("memoriser")(!!v)} data-testid="revenu-direct-memoriser" />
          <span>Mémoriser « {depot.payeur} » : ses autres virements, passés et futurs, seront associés automatiquement à ce logement.</span>
        </label>
      )}
      <div className="flex justify-end">
        <Button disabled={!f.logement || loading} onClick={submit} className="bg-emerald-700 hover:bg-emerald-800" data-testid="revenu-direct-submit">
          {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Associer au logement
        </Button>
      </div>
    </div>
  );
};
